import { useEffect, useState } from 'react';
import { ExportLinkedAccountsHistoryAPI, GetIndividualSpendAccountsAPI, GetSpendAcrossAccountsAPI, } from '../api/oms/linked-accounts';
import { redirectToDownloadsPage } from '../utils/general';
export var FetchIndividualSpendAccounts = function (requestData, setHierarchyName) {
    var _a = useState(null), individualSpendAccountsData = _a[0], setIndividualSpendAccountsData = _a[1];
    var _b = useState(null), individualSpendAccountsError = _b[0], setIndividualSpendAccountsError = _b[1];
    var _c = useState(false), individualSpendAccountsLoaded = _c[0], setIndividualSpendAccountsLoaded = _c[1];
    useEffect(function () {
        GetIndividualSpendAccountsAPI(requestData)
            .then(function (response) {
            setIndividualSpendAccountsData(response.data);
            setHierarchyName(response.data.hierarchyName);
        })
            .catch(function (error) { return setIndividualSpendAccountsError(error); })
            .finally(function () { return setIndividualSpendAccountsLoaded(true); });
    }, [requestData.familyMembersRequest.pageNumber]);
    return {
        individualSpendAccountsData: individualSpendAccountsData,
        individualSpendAccountsError: individualSpendAccountsError,
        individualSpendAccountsLoaded: individualSpendAccountsLoaded,
    };
};
export var FetchSpendAcrossAccounts = function (requestData) {
    var _a = useState(null), spendAcrossAccountsData = _a[0], setSpendAcrossAccountsData = _a[1];
    var _b = useState(null), spendAcrossAccountsError = _b[0], setSpendAcrossAccountsError = _b[1];
    var _c = useState(false), spendAcrossAccountsLoaded = _c[0], setSpendAcrossAccountsLoaded = _c[1];
    useEffect(function () {
        GetSpendAcrossAccountsAPI(requestData)
            .then(function (response) {
            return setSpendAcrossAccountsData(response.data);
        })
            .catch(function (error) { return setSpendAcrossAccountsError(error); })
            .finally(function () { return setSpendAcrossAccountsLoaded(true); });
    }, []);
    return {
        spendAcrossAccountsData: spendAcrossAccountsData,
        spendAcrossAccountsError: spendAcrossAccountsError,
        spendAcrossAccountsLoaded: spendAcrossAccountsLoaded,
    };
};
export var StartExportLinkedAccountsHistory = function (requestData, setShowWarning, setBtnLoading) {
    ExportLinkedAccountsHistoryAPI(requestData)
        .then()
        .catch(function (error) {
        var _a, _b, _c, _d, _e;
        if ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errorData) {
            var errorData = (_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.errorData.errors.error;
            if (errorData &&
                ((_e = errorData[0]) === null || _e === void 0 ? void 0 : _e.code) === 'OFFLINE_CSV_DOWNLOAD_ERR_7004') {
                setShowWarning(true);
            }
        }
    })
        .finally(function () {
        setBtnLoading(false);
        redirectToDownloadsPage('linkedAccountsRedirect');
    });
};
